/* eslint-disable */
// We need to do common size revenue values too!
import React, { useContext } from 'react';
import { Data, Filters } from './contexts';
import AccountTree from "../utils/AccountTree";
import { parseMoney } from "../utils";
import { CommonSizeArrows } from "./report_components/MoneyHelpers";

const compareWithRowKeys = {
    'None': null,
    'Practice': 'practice_avg',
    'Peers': 'avg',
    'NSCHBC': 'nschbc',
    "Peers - Top 10% Fastest Growing": "top_10_revenue_growth",
    "Peers - Top 25% Fastest Growing": "top_25_revenue_growth",
    "Peers - Top 10% Most Profitable": "top_10_net_profit",
    "Peers - Top 25% Most Profitable": "top_25_net_profit"
}
const revenue621Accounts = [
    { key: 'total_revenue_gross_charges', copy: 'Gross Charges' },
    { key: 'total_revenue_adjustments', copy: 'Adjustments' },
    { emptyRow: true },
]

const PnlByClass = (props) => {
    const { calcs } = useContext(Data);
    const { filters } = useContext(Filters);
    const finalFilters = props.tabFilters || filters;
    const compareWith = finalFilters.compare_with;
    const calcsAvgType = compareWithRowKeys[compareWith]
    const avgCalcs = calcsAvgType && props.aggregateData ? props.aggregateData?.annual?.[calcsAvgType] : calcsAvgType ? props.calcs?.[calcsAvgType] : null;
    let numberCompare = 0;
    if (props.page === 'practice') {
      numberCompare = props.n
    } else {
      numberCompare = props.aggregateData?.annual_n?.[props.year] ?? 0;
    }
    const youData = props.calcs?.you_by_class?.[props.year]
    const emptyRowVals = youData?.headers ? youData?.headers.slice(1).map(h => 0) : []

    const currentYear = new Date().getFullYear();
    let pnlRows = props.rows;
    if (pnlRows.length === 0) {
        const pnlTreeAll = new AccountTree({
            tree: props.tree?.['pnl'],
            page: 'money',
            sheet: 'pnl'
        })
        pnlTreeAll.forEach((row) => {
            pnlRows.push(row)
        })
        pnlRows = pnlRows.filter(Boolean)
    }


    const renderHeaderColumns = (pdfHeaders = null) => {
        const year = Number(props.year)
        let headers = pdfHeaders || youData.headers.slice(1);
        let youDate, compareDate = '';
        // Need to handle different fiscal year end
        let tableYearDisplay = props.calendarYearEnd ? year : `FY${year + 1}`
        if (year === currentYear) {
            youDate = props.companyYTDDate;
            compareDate = props.aggregateYTDDate;
        } else {
            youDate = props.calendarYearEnd ? `${props.fiscalYearEnd}/${year}` : props.fiscalYearEnd ? `${props.fiscalYearEnd}/${year + 1}` : `12/31/${year}`;
            compareDate = `12/31/${year}`;
        }

        return (
            <thead>
                <tr key='pnl-class-header'>
                    <td></td>
                    {headers.map((header, i) => {
                        let cssClasses = i % 2 === 0 ? 'money-table-cell' : '';
                        return (
                            <>
                                <td colSpan={'2'} className={cssClasses}>
                                    {header.ColTitle}
                                </td>
                                <td></td>
                            </>
                        )
                    })}
                    {calcsAvgType ? <td><div className='compare-with-title'>{compareWith}</div></td> : <td></td>}
                </tr>
                <tr key='pnl-class-header-years'>
                    <td></td>
                    {headers.map((h, i) => {
                        let cssClasses = i % 2 === 0 ? 'money-table-cell' : '';
                        return (
                            <>
                                <td colSpan={'2'} className={cssClasses}>
                                    {youDate}
                                </td>
                                <td></td>
                            </>
                        )
                    })}
                    {calcsAvgType ? <td>{compareDate}</td> : <td></td>}
                </tr>
            </thead>
        )
    }

    const commonSizeArrowSign = (youCommonSize, compareCommonSize, key = '') => {
        let commonSizeArrow = CommonSizeArrows(youCommonSize, compareCommonSize, key)
        if (commonSizeArrow === 'worse' || commonSizeArrow === 'worst') {
            return <p className='common-size-arrow-red' style={{ margin: 0, color: 'red' }}>&#9660;</p>
        } else if (commonSizeArrow === 'better' || commonSizeArrow === 'best') {
            return <p className='common-size-arrow-green' style={{ margin: 0, color: 'green' }}>&#9650;</p>
        }
    }

    // Just need metrics in the Operating Expsenses section that divide into Program Services, Admin, and Fundraising
    const buildRows = (headerIndexes = null) => {
        let reportRows = []
        const avgTotalRevenue = avgCalcs ? avgCalcs?.['total_revenue']?.[props.year] : null;
        if (props.naicsCode.startsWith('621')) {
            pnlRows = [...revenue621Accounts, ...pnlRows]
        }

        pnlRows.forEach((row, index) => {
            let underlineFormat, toplineFormat;
            if (row.forecast) {
                if (row.forecast.total) {
                    if (row.forecast.total.boldedUnderline) {
                        underlineFormat = 'solid 1px';
                    } else if (row.forecast.total.doubleUnderline) {
                        underlineFormat = 'double 1px';
                    } else if (row.forecast.total.underline) {
                        underlineFormat = 'solid 1px';
                    }

                    if (row.forecast.total.topline) {
                        toplineFormat = 'solid 1px'
                    } else {
                        toplineFormat = ''
                    }

                } else {
                    if (row.forecast.boldedUnderline) {
                        underlineFormat = 'solid 1px';
                    } else if (row.forecast.doubleUnderline) {
                        underlineFormat = 'double 1px';
                    } else if (row.forecast.underline) {
                        underlineFormat = 'solid 1px';
                    }

                    if (row.forecast.topline) {
                        toplineFormat = 'solid 1px'
                    } else {
                        toplineFormat = ''
                    }
                }
            }

            if (row.topline) {
                toplineFormat = 'solid 1px'
            }

            const copyRowStyle = {
                ...row.style,
                borderBottom: underlineFormat,
                borderTop: toplineFormat,
                height: '20px'
            }

            const copyCellStyle = row.whiteSpace ? 'table-copy wrap-copy-cell' : 'table-copy';
            let rowData = youData.data?.[row.key] || emptyRowVals;
            let commonSizeData = youData.data?.[`${row.key}_common_size_revenue`] || emptyRowVals;
            if (props.pdf) {
                rowData = rowData.slice(headerIndexes[0], headerIndexes[headerIndexes.length - 1])
                commonSizeData = commonSizeData.slice(headerIndexes[0], headerIndexes[headerIndexes.length - 1])
            }
            const copy = (row?.padding || '') + (row?.copy || '');
            let commonSizeValCellClass = props.pdf ? 'common-size-cell-pdf' : 'common-size-cell';

            if (row.emptyRow || (row.header && !row.header_is_total)) {
                    reportRows.push(
                        <tr style={copyRowStyle} key={`pnl-by-class-${row.key}-${Math.random()}`}>
                            <td className='table-copy'>{copy}</td>
                            {rowData.map((d, i) => {
                                let cssClasses = i % 2 === 0 ? 'money-table-cell' : '';
                                let finalCommonSizeClass = i % 2 === 0 ? `${commonSizeValCellClass} money-table-cell` : commonSizeValCellClass;
                                return (
                                    <>
                                        <td className={cssClasses}>
                                        </td>
                                        <td className={finalCommonSizeClass}></td>
                                        <td></td>
                                    </>
                                )
                            })}
                            <td className={commonSizeValCellClass}></td>
                        </tr>
                    )
            } else {
                let avgVal = avgTotalRevenue ? avgCalcs?.[row.key]?.[props.year] : null;
                let avgValCs = avgVal ? ((avgVal / avgTotalRevenue) * 100).toFixed(1) + '%' : '0.0%';

                reportRows.push(
                    <tr style={copyRowStyle} key={`pnl-by-class-${row.key}-${Math.random()}`}>
                        <td className='table-copy'>{copy}</td>
                        {rowData.map((d, i) => {
                            const cssClasses = i % 2 === 0 ? 'money-table-cell' : '';
                            let finalCommonSizeClass = i % 2 === 0 ? `${commonSizeValCellClass} money-table-cell` : commonSizeValCellClass;
                            const commonSizeVal = commonSizeData?.[i] ? commonSizeData[i].toFixed(1) + '%' : '0.0%';
                            return (
                                <>
                                    <td className={cssClasses}>
                                        {parseMoney(d)}
                                    </td>
                                    <td className={finalCommonSizeClass}>
                                        {commonSizeVal}
                                    </td>
                                    <td></td>
                                </>
                            )
                        })}
                        <td className={commonSizeValCellClass}>
                            {avgValCs}
                        </td>
                    </tr>
                )
            }
        })
        return reportRows
    }

    const buildTable = () => {
        if (props.calcs?.you_by_class) {
            if (props.pdf) {
                let start = 1;
                let end = 5;
                let maxColumnsPerPage = 4;
                // Exclude 'Account' header
                let classHeaders = [...youData.headers, ...youData.headers]
                let headerIndexes = []
                const pageCount = Math.ceil((classHeaders.length - 1) / maxColumnsPerPage);
                let pageBreakUp = []

                for (let i = 1; i <= pageCount; i++) {
                    let indexStop = i == pageCount ? classHeaders.length : (start + maxColumnsPerPage)
                    pageBreakUp.push(classHeaders.slice(start, end))
                    let a = [];
                    for (let j = start - 1; j < indexStop; j++) {
                        a.push(j);
                    }
                    headerIndexes.push(a)

                    start = end;
                    end = i == pageCount ? 0 : end + maxColumnsPerPage
                }
                let clientNames = props.realName ? `${props.realName} / ${props.clientName}` : props.clientName;
                const tabName = (props.tabName || props.title || '').trim().toLowerCase();
                const title = (props.title || '').trim().toLowerCase();
                let reportTitle = tabName.includes(title) ? props.tabName || props.title : `${props.tabName}, ${props.title}`;
                let naicsCode = props.tabFilters.code;
                let dataType = props.tabFilters.datatype;
                let revenueBand = props.tabFilters.revenue_band;
                let region = props.tabFilters.region;
                let compare = props.tabFilters.compare_with
                let filtersTitle = `NAICS: ${naicsCode}, Data Type: ${dataType}, Revenue: ${revenueBand}, Region: ${region}, Compare with: ${compare}`;

                return pageBreakUp.map((classHeaders, i) => { 
                    return (
                        <div className='money-pdf-portrait'>
                            <div>
                                <div>
                                    <p className='report-annual-title'>{`${reportTitle}, ${clientNames}`}</p>
                                    <p className='report-filters-title'>{filtersTitle}</p>
                                </div>
                                <div className='money-pdf-table-div'>
                                    <table style={{ whiteSpace: 'pre' }} className='money-pdf-table' >
                                        {renderHeaderColumns(classHeaders)}
                                        <tbody>
                                            {buildRows(headerIndexes[i])}
                                            <tr><td className='footer-cell'><i>n = {numberCompare}</i></td></tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <p className='pdf-disclaimer-text'>{`These financial statements have been prepared by ${props.firmName}, and have not been subjected to an audit or review or compilation engagement, and no assurance is provided on them. These financial statements are intended for management’s internal use only. Substantially all disclosures omitted.`}</p>
                        </div>
                    )
                })
            } else {
                let tableID = `new-annual-table-naics_focused`
                return (
                    <div className='money-report-card'>
                        <div className='money-report-pdf'>
                            <div className='money-report-container'>
                                <table id={tableID} style={{ whiteSpace: 'pre' }} className='report-table' >
                                    {renderHeaderColumns()}
                                    <tbody>
                                        {buildRows()}
                                        <tr><td className='footer-cell'><i>n = {numberCompare}</i></td></tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                )
            }
        }
    }

    return (buildTable())
}

export default PnlByClass;